import PropTypes from 'prop-types';
import passengerPropType from './passenger';

export default PropTypes.arrayOf(passengerPropType);
